/**
 * Created by eriksundqvist on 11/05/16.
 */

import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { CurrenciesService } from 'frilans-finans';
import { toMoney } from './amount-helper';
import ReadMoreModal, { VAT } from '../read-more-modal/read-more-modal';
import { vat, getVatById, reformatInputValue } from '../invoice-tool-helper';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';

const DEFAULT_COUNTRY = 'SWEDEN';
const DEFAULT_CURRENCY_ID = 1;
const DEFAULT_CURRENCY_DEFAULT_TAX_ID = 1;
const NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID = 4;

export class Amount extends React.Component {

  static propTypes = {
    amount: PropTypes.number.isRequired,
    setAmount: PropTypes.func.isRequired,
    currencyId: PropTypes.number.isRequired,
    currencyAmount: PropTypes.number.isRequired,
    setCurrencyId: PropTypes.func.isRequired,
    setCurrencyName: PropTypes.func.isRequired,
    setCurrencyAmount: PropTypes.func.isRequired,
    setTaxId: PropTypes.func.isRequired,
    taxkeys: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired,
    submitted: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      activeCurrency: null,
      activeCurrencyId: null,
      currencies: [],
      renderModal: false,
      amountTouched: false
    };

    this.billAmountInputBlur = this.billAmountInputBlur.bind(this);
    this.renderCurrencyVat = this.renderCurrencyVat.bind(this);
    this.setActiveCurrency = this.setActiveCurrency.bind(this);
    this.setTaxId = this.setTaxId.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount () {
    this.fetchCurrencies();
    this.props.setTaxId(DEFAULT_CURRENCY_DEFAULT_TAX_ID);
  }

  componentWillReceiveProps (nextProps) {
    if (!this.state.activeCurrency) {
      return;
    }

    // On amount updated
    if (nextProps.currencyAmount !== 0 && this.props.currencyAmount !== nextProps.currencyAmount) {
      this.setBillAmountToField(nextProps.currencyAmount);
    }

    // On currency updated. Set the new currency object and update amount in store
    if (this.props.invoice.currencyId !== nextProps.invoice.currencyId && this.state.currencies.length > 0) {
      let currency = null;

      for (let c of this.state.currencies) {
        if (parseInt(c.id) === parseInt(nextProps.currencyId)) {
          currency = c;
        }
      }

      if (currency) {
        this.setState({
          activeCurrencyId: nextProps.currencyId,
          activeCurrency: currency
        }, () => {
          this.storeBillAmount(this.refs.billAmountInput.value);
        });
      }
    }

    if ((this.props.invoice.hsd.rot !== nextProps.invoice.hsd.rot ||
      this.props.invoice.hsd.rut !== nextProps.invoice.hsd.rut) &&
      nextProps.invoice.hsd.rot || nextProps.invoice.hsd.rut) {
      if (nextProps.invoice.taxId !== DEFAULT_CURRENCY_DEFAULT_TAX_ID) {
        this.props.setTaxId(DEFAULT_CURRENCY_DEFAULT_TAX_ID);
      }
    }
  }

  fetchCurrencies () {
    CurrenciesService.get()
      .then((response) => this.handleCurrenciesResponse(response));
  }

  handleCurrenciesResponse (apiResult) {
    var standardCurrency;

    for (let i = 0; i<apiResult.collection.length; i++) {
      if (apiResult.collection[i].standard === true) {
        standardCurrency = apiResult.collection[i];
        break;
      }
    }
    this.setState({
      activeCurrency: standardCurrency,
      currencies: apiResult.collection
    }, () => {
      this.storeCurrencyId(standardCurrency.id);
      this.storeCurrencyName(standardCurrency.name);
    });
  }

  storeCurrencyId (currencyId) {
    this.props.setCurrencyId(parseInt(currencyId));
    if (!this.props.invoice.initializing &&
      parseInt(currencyId) !== DEFAULT_CURRENCY_DEFAULT_TAX_ID) {
      this.toggleModal();
    }
  }

  storeCurrencyName (currencyName) {
    this.props.setCurrencyName(currencyName);
  }

  getCurrencyById (id) {
    for (let currencyEntity of this.state.currencies) {
      if (currencyEntity.id === id) {
        return currencyEntity;
      }
    }
    return null;
  }

  setActiveCurrency (event) {
    var currency = this.getCurrencyById(event.target.value);

    /**
    * Currency dictate VAT in a way that can't be directly read from the currency data
    * Therefore a currency change will have to trigger a tax change in cases when it is not the default currency
    */
    if (currency.id !== DEFAULT_CURRENCY_ID) {
      this.props.setTaxId(NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID);
    }

    this.setState({
      activeCurrency: currency,
      activeCurrencyId: currency.id
    }, () => {
      this.storeCurrencyId(currency.id);
      this.storeCurrencyName(currency.name);
    });
  }

  billAmountInputBlur (event) {
    let amountValue = event.target.value;
    amountValue = reformatInputValue(amountValue);
    this.storeBillAmount(amountValue);

    this.setState({
      amountTouched: true
    });
  }

  /**
   * Store the amount from the input field in the store. Multiply with the current exchange rate
   */
  storeBillAmount (billAmount) {
    if (!this.state.activeCurrency) {
      return;
    }
    let storeAmount = this.state.activeCurrency.exchangeRate * billAmount;

    this.props.setCurrencyAmount(billAmount);
    this.props.setAmount(storeAmount);
  }

  /**
   * When amount is updated from somewhere else. Take the store value and divide with current exchange rate
   */
  setBillAmountToField (billAmount) {
    if (billAmount !== 0) {
      this.refs.billAmountInput.value = toMoney(billAmount);
    } else {
      this.refs.billAmountInput.value = '0';
    }
  }

  setTaxId (event) {
    this.props.setTaxId(parseInt(event.target.value));
    this.toggleModal();
  }

  toggleModal (e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      renderModal: !this.state.renderModal
    });
  }

  focus (e) {
    e.target.select();
  }

  renderError () {
    if ((this.props.submitted || this.state.amountTouched) &&
      !InvoiceValidator.validateAmount(this.props.amount)) {
      return (
        <p className="error"><Translate content='INVOICE_ERROR_AMOUNT'/></p>
      );
    }
  }

  renderModal () {
    if (this.state.renderModal) {
      return (
        <ReadMoreModal
          close={this.toggleModal}
          text={VAT}
        />
      );
    }
  }

  renderCurrencyVat (amountIncVat, hide = 'hide-mobile') {
    return (<div className={'currency-vat-right ' + hide}>
      <p>
        <Translate content={
          this.props.invoice.taxId === NON_DEFAULT_CURRENCY_DEFAULT_TAX_ID
          ? 'AMOUNT'
          : 'AMOUNT_INCL_VAT'}
        />
        {' '}
        <span>{toMoney(amountIncVat)}</span>
        {' '}
        <Translate content='DEFAULT_CURRENCY_NAME_SHORT'/>
      </p>
    </div>);
  }

  render () {
    if (!this.state.activeCurrency) {
      return (
        <div></div>
      );
    }

    let hsdAmount;
    let customer = this.props.invoice.customerEntity;
    let country = customer != null ? customer.address.country : false;
    let hsdAmountExclVat = this.props.invoice.amountAfterHsd || 0;
    let hsdAmountIncVat = hsdAmountExclVat
      ? Math.round(hsdAmountExclVat * (1 + (getVatById(this.props.invoice.taxId) / 100)))
      : 0;
    let amountIncVat = hsdAmountIncVat || this.props.invoice.amountIncVat;

    if ((country === 'SWEDEN' || !country) &&
      (this.props.invoice.hsd.rot || this.props.invoice.hsd.rut)) {
      const hsdTextType = this.props.invoice.hsd.rot ? 'ROT' : 'RUT';
      const hsdText = `AMOUNT_TO_BILL_HSD_${hsdTextType}_EXCL_VAT`;
      const hsdValue = toMoney(this.props.invoice.amountAfterHsd || 0);
      const hsdAmountValue = `${hsdValue} ${this.state.activeCurrency.name}`;
      hsdAmount = (
        <div className='hsd-amount'>
          <div className='left-bg'>
            <div className='text-holder'>
              <Translate content={hsdText} />
            </div>
          </div>
          <div className='right-bg'>
            <div className='text-holder'>
              <span>{hsdAmountValue}</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className='amount-container'>
        <div className='amount blue-box'>
          <div className='left-bg'>
            <div className='text-holder'>
              <Translate content='AMOUNT_TO_BILL_EXCL_VAT'/>
            </div>
          </div>
          <div className='right-bg'>
            <div
              className='input-holder currency-input-holder'
              data-currency={this.state.activeCurrency.name}>
              <input type='text'
                onBlur={this.billAmountInputBlur}
                onClick={this.focus}
                name='amount'
                defaultValue='0'
                ref={'billAmountInput'}
                />
            </div>
            {this.renderCurrencyVat(amountIncVat, 'hide-until-mobile')}
          </div>
        </div>
        <div className='currency-vat'>
          <div className='currency-vat-left'>
            <div className='currency-vat-select-holder'>
              <div className='currency-vat-p-select'>
                <Translate component={'p'} content='CURRENCY'/>
                <p>: </p>
                <div className='select-btn-wrapper'>
                  <div className='styled-amount-select'>
                    <label>
                      <select
                        value={(this.state.activeCurrencyId) ? this.state.activeCurrencyId : DEFAULT_CURRENCY_ID}
                        onChange={this.setActiveCurrency}>
                        {
                          this.state.currencies.map(function (item, i) {
                            return (
                              <option value={item.id} key={i} >{item.name}</option>
                            );
                          })
                        }
                      </select>
                    </label>
                  </div>
                </div>
              </div>
              <div className='currency-vat-p-select'>
                <Translate component={'p'} content='VAT'/>
                <p>: </p>
                <div className='select-btn-wrapper'>
                  <div className='styled-amount-select'>
                    <label>
                      <select
                        value={this.props.invoice.taxId}
                        onChange={this.setTaxId}
                        disabled={this.state.activeCurrencyId !== DEFAULT_CURRENCY_ID ||
                          (this.props.invoice.customerEntity !== null &&
                          this.props.invoice.customerEntity.address.country !== DEFAULT_COUNTRY) ||
                          this.props.invoice.hsd.rot || this.props.invoice.hsd.rut}>
                        {
                          vat.map(function (item, i) {
                            return (
                              <option value={item.id} key={i}>{item.value}%</option>
                            );
                          })
                        }
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.renderCurrencyVat(amountIncVat)}
        </div>
        {hsdAmount}
        {this.renderError()}
        {this.renderModal()}
      </div>
    );
  }
}

export default Amount;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/amount/amount.js
 **/